import React, { PureComponent } from 'react';
import {Helmet} from 'react-helmet';
import intl from 'react-intl-universal';

import { Status } from 'components';

export default class NotFound extends PureComponent {
  render() {
    let {text} = this.props;
    if(!text) {
      text = 'The page you are looking for does not exist.';
    }
    return (
      <Status status={ 404 }>
        <Helmet>
          <title>{intl.get('404 Not Found | ImageResize.org')}</title>
        </Helmet>
        <div className="container center">
          <h1>{ 'Not Found' }</h1>
          <h3>{ text }</h3>
        </div>
      </Status>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotFound/index.jsx